// extracted by mini-css-extract-plugin
export default {"color":"skyblue","primary-color":"red","footer-height":"170px","transparent":"rgba(0,0,0,0)","transparentPartial":"rgba(0,0,0,0)"};